<template>
  <div class="__custom_timer">
    <span class="_hour">{{ hour }}</span>
    <span>:</span>
    <span class="_minute">{{ minute }}</span>
    <span>:</span>
    <span class="_second">{{ second }}</span>
  </div>
</template>

<script>
const f = (v) => {
  v = `${v}`;
  if (v.length < 2) v = `0${v}`;
  return v;
};

export default {
  props: {
    duration: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    hour() {
      return f(Math.floor(this.duration / 1000 / 60 / 60) || 0);
    },
    minute() {
      return f(
        Math.floor((this.duration / 1000 - this.hour * 60 * 60) / 60) || 0
      );
    },
    second() {
      return f(
        Math.floor(
          this.duration / 1000 - this.hour * 60 * 60 - this.minute * 60
        ) || 0
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.__custom_timer {
  font-size: 1.3rem;
}
._hour,
._minute {
  font-weight: bold;
}

._hour {
  margin-right: 5px;
}
._minute {
  margin: 0 5px;
}
._second {
  margin-left: 5px;
  font-weight: 300;
}

._hour,
._minute,
._second {
  letter-spacing: 2px;
}
</style>
